import React from "react";

import SubBoxWrapper from "../../wrapper/SubBoxWrapper";

import NoItem from "../util/NoItem";

import ListItem from "./ListItem";

function RecentStudy({ menuLink, recentStudyList, titleText, noItemText, menuTypeCode, info, drawCd }) {
    return (
        <SubBoxWrapper
            info={info}
            titleText={titleText}
            menuLink={menuLink}
            menuTypeCode={menuTypeCode}
            customClassName={"recentlyStudy"}
            drawCd={drawCd}
        >
            {recentStudyList ? (
                recentStudyList.map((info, idx) => <ListItem info={info} key={idx} />)
            ) : (
                <NoItem titleText={noItemText} />
            )}
        </SubBoxWrapper>
    );
}

export default RecentStudy;
